import { render, staticRenderFns } from "./InventarioHistorico.vue?vue&type=template&id=24f70eda&scoped=true"
import script from "./InventarioHistorico.vue?vue&type=script&lang=js"
export * from "./InventarioHistorico.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./InventarioHistorico.vue?vue&type=style&index=1&id=24f70eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f70eda",
  null
  
)

export default component.exports